import {Status} from './demande-abs.model';

export const statusList: Status[] = [
  {label: 'En cours', value: 0},
  {label: 'Validé', value: 1},
  {label: 'Rejeté', value: 2},
];
